<template>
  <div class="w-full chart-container relative"
    :style="{'height': height, 'min-width': minWidth, 'max-width': maxWidth}"
    >
    <label class="w-full text-center text-lg font-semibold text-secondary-600 dark:text-darkblue-200 block mb-1" 
      v-if="isLower1024 && !isEmpty">
      {{ this.totalTareas }} Acciones realizadas
    </label>
    <label class="w-full text-center text-lg font-semibold text-secondary-600 dark:text-darkblue-200 block mb-1" 
      v-if="isLower1024 && !isEmpty">
      ¡La realización manual de estas acciones habría requerido {{ this.totalHoras }} horas de trabajo!
    </label>
    <canvas class="p-2" :id="id" :aria-label="ariaLabel" :tabindex="isEmpty ? -1 : 0"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js'

export default {
  name: 'Chart',
  props: {
    type: {
      type: String,
      default: 'doughnut'
    },
    id: {
      type: String,
      default: 'chart-doughnut'
    },
    chardataDonut: {
      type: [Array, Object]
    },
    totalTareas: {
      type: Number,
      default: 0,
    },
    totalHoras: {
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
      ChartData: null,
      myChart: null,
      colorPrimary: this.getColor('--primary-300'),
      colorFont: this.getColor('--secondary-DEFAULT'),
      colorFontDark: this.getColor('--secondary-100'),
      colorBorder: '#ffffff',
      colorBorderDark: this.getColor('--secondary-800'),
      colorPrimaryText: this.getColor('--primary-800'),
      colorPrimaryTextDark: this.getColor('--primary-100'),
    }
  },
  computed: {
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    isEmpty () {
      if (!this.chardataDonut || this.chardataDonut.length === 0) return true
      return false
    },
    height () {
      return 400 + 'px'
    },
    minWidth () {
      return 320 + 'px'
    },
    maxWidth () {
      return 800 + 'px'
    },
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    ariaLabel () {
      var msg = ''
      if (this.chardataDonut) {
        if (this.totalTareas && this.totalTareas > 0) {
          msg+= 'Total de acciones realizadas: ' + this.totalTareas + ';'
          this.chardataDonut.forEach(x => {
            msg += '' + x.Leyenda + ': ' + x.Descripcion + '; '
          })
        } else {
          msg += this.$t('clients.chart_report_default_empty')
        }
      }
      return msg
    },
    actualWidth () {
      return window.innerWidth
    },
    divisionRender () {
      if (this.actualWidth < 1200) {
        return 3.8
      }
      return 3.3
    }
  },
  watch: {
    chardataDonut: 'dataChangeHandler',
    darkMode: 'changeDarkmode'
  },
  methods: {
    getColor (property) {
      return getComputedStyle(document.querySelector(':root')).getPropertyValue(property)
    },
    changeDarkmode: function () {
      Chart.defaults.global.defaultFontColor = this.darkMode ? this.colorFontDark : this.colorFont
      this.myChart.config.options.legend.labels.fontColor = this.darkMode ? this.colorFontDark : this.colorFont
      this.updateFixChart()
    },
    updateFixChart () {
      this.myChart.update()
      setTimeout(() => {
        this.myChart.update()
      }, 200)
    },
    dataChangeHandler: function () {
      Chart.defaults.global.defaultFontColor = this.darkMode ? this.colorFontDark : this.colorFont
      const ctx = document.getElementById(this.id)
      this.ChartData = null
      const self = this
      const labels = this.chardataDonut.map(x => {
        let msg = x.Leyenda + ': ' + new Intl.NumberFormat('es-ES').format(x.Tareas) + ' acciones'
        // let msg = x.Leyenda + ': ' + x.Porcentaje + '%'
        // Rellenamos para evitar que se lie al dibujar en el medio del donut
        if (msg.length < 38) {
          let iterations = 38 - msg.length
          if (iterations > 3) iterations = iterations - 3
          for (let index = 0; index < iterations; index++) {
            msg += '  '
          }
        }
        return msg
      })
      const data = this.chardataDonut.map(x => x.TareasMinimas)
      const colors = this.chardataDonut.map(x => x.Color)
      this.ChartData = {
        type: 'doughnut',
        data: {
          labels: labels,
          datasets: [{
            label: 'Acciones realizadas',
            data: data,
            backgroundColor: colors,
            borderColor: this.darkMode ? this.colorBorderDark : this.colorBorder,
            hoverOffset: 10, // Expande el borde al hacer hover
            hoverBorderWidth: 6, // Grosor del borde al hacer hover
            // hoverBorderColor: this.darkMode ? this.colorFont : this.colorFontDark, // Color del borde al hacer hover
          }]
        },
        options: {
          maintainAspectRatio: false,
          responsive: true,
          legend: {
            display: true,
            position: 'right',
            boxWidth: 3,
            maxWidth: 2,
            labels: {
              fontColor: this.darkMode ? this.colorFontDark : this.colorFont,
              fontSize: 14,
              backgroundColor: this.colorPrimary,
            },
            onHover: (evt, legendItem) => {
              const target = evt.native ? evt.native.target : evt.target
              target.style.cursor = 'pointer' 
            },
          },
          title: {
            display: false,
            text: 'Total de acciones realizadas'
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                return self.chardataDonut[tooltipItem.index].Descripcion
              },
              title: function (tooltipItems, data) {
                return self.chardataDonut[tooltipItems[0].index].Leyenda + ': ' + self.chardataDonut[tooltipItems[0].index].Porcentaje + '%'
                // return data.labels[tooltipItems[0].index]
              }
            }
          },
          onHover: (event, chartElement) => {
            const target = event.native ? event.native.target : event.target
            target.style.cursor = chartElement[0] ? 'pointer' : 'default'
          },
        },
        plugins: [
          {
            id: 'centerText',
            beforeDraw (chart) {
              const defaultText = 'No tiene datos suficientes'
              const defaultText2 = 'para generar el informe'
              const { width } = chart
              const { height } = chart
              const ctx = chart.ctx
              const tareas = self.totalTareas + '' 
              const textDefault = 'Acciones' 
              const textDefault2 = 'realizadas' 
              const horas = self.totalHoras + '' 
              const textDefaultHoras = '¡La realización manual de estas acciones' 
              const textDefaultHoras1 = 'habría requerido' 
              const textDefaultHoras2 = 'horas' 
              const textDefaultHoras3 = 'de trabajo!' 
              const textDefaultHoras4 = 'EdasNEO sigue trabajando para ti' 
              const fontSizeLower1024 = 12
              const fontSizeTextoTareas = 20
              const fontSize = 16
              const fontSizeTareas = 30
              const lineSpacing = 4
              const initialMaginTop = 1

              ctx.save()
              ctx.font = `bold ${self.isEmpty ? fontSize : fontSizeTareas}px Arial`
              ctx.textBaseline = 'middle'
              ctx.textAlign = 'center'
              ctx.fillStyle = self.darkMode ? '#FFF' : '#000'

              const totalHeight = fontSize * 2 + lineSpacing 
              let startY = (height / 2) - (totalHeight / 2)

              if (self.isEmpty) {
                // Pintar texto cuando esta vacio
                ctx.fillText(defaultText, width / 2, startY + initialMaginTop)
                startY += fontSizeTareas + lineSpacing    
                ctx.fillText(defaultText2, width / 2, startY + initialMaginTop)
                startY += fontSizeTareas + lineSpacing    
              } else {
                if (!self.isLower1024) {
                  // Pintar texto de tareas realizadas centrado
                  ctx.font = `semibold ${self.isLower1024 ? fontSize : fontSizeTareas}px Arial`
                  ctx.fillText(new Intl.NumberFormat('es-ES').format(tareas), width / self.divisionRender, startY + initialMaginTop)
                  startY += (self.isLower1024 ? fontSize : fontSizeTareas) + lineSpacing    
                  ctx.font = `bold ${self.isLower1024 ? fontSizeLower1024 : fontSizeTextoTareas}px Arial`
                  ctx.fillText(textDefault, width / self.divisionRender, startY + initialMaginTop)
                  startY += (self.isLower1024 ? fontSizeLower1024 : fontSize) + lineSpacing
                  ctx.fillText(textDefault2, width / self.divisionRender, startY + initialMaginTop)
                  // Pintar texto de horas automatizadas debajo de la leyenda
                  startY = (height * 0.9) - (totalHeight * 0.9)
                  ctx.font = `bold ${fontSize}px Arial`
                  ctx.fillText(`${textDefaultHoras}`, width * 0.8, startY + initialMaginTop)
                  startY += (self.isLower1024 ? fontSize : fontSizeTareas) + lineSpacing - 10  
                  ctx.fillText(`${textDefaultHoras1} ${new Intl.NumberFormat('es-ES').format(horas)} ${textDefaultHoras2} ${textDefaultHoras3}`, width * 0.8, startY)
                  startY += (self.isLower1024 ? fontSize : fontSizeTareas) + lineSpacing    
                  ctx.fillStyle = self.darkMode ? self.colorPrimaryTextDark : self.colorPrimaryText
                  ctx.fillText(`${textDefaultHoras4}`, width * 0.8, startY)
                } 
              }
              ctx.restore()
            }
          },
          // {
          //   id: 'legendCursorPointer',
          //   beforeInit (chart) {
          //     console.log('chart', chart)
          //     console.log('chart.legend.options', chart.legend.options)
              
          //     chart.legend.options.onHover = (event) => {
          //       event.native.target.style.cursor = 'pointer'
          //     }
          //   }
          // },
        ],
      }
      // eslint-disable-next-line no-new
      const myChart = new Chart(ctx, this.ChartData)
      this.myChart = myChart
      ctx.onclick = function (evt) {
        const activePoint = myChart.getElementAtEvent(evt)[0]
        if (activePoint && activePoint._chart) {
          const data = activePoint._chart.data
          const datasetIndex = activePoint._datasetIndex
          const label = data.labels[activePoint._index]
          const value = data.datasets[datasetIndex].data[activePoint._index]
          console.log(label, value)
          self.$emit('callback', label)
        }
      }
      this.changeDarkmode()
    }
  }
}
</script>
